const arrowrightIcon = `
<?xml version="1.0" encoding="UTF-8"?>
<svg width="5px" height="9px" viewBox="0 0 5 9" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 57.1 (83088) - https://sketch.com -->
    <title>Line_Icons</title>
    <desc>Created with Sketch.</desc>
    <g id="Settings-" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="DB-Settings--PS--overlay" transform="translate(-364.000000, -141.000000)" fill="#606060" fill-rule="nonzero">
            <g id="Breadcrumb" transform="translate(284.000000, 132.000000)">
                <g id="data-download-14" transform="translate(82.500000, 13.500000) rotate(-90.000000) translate(-82.500000, -13.500000) translate(75.000000, 6.000000)">
                    <g id="Line_Icons" transform="translate(3.125000, 5.000000)">
                        <g id="Group">
                            <path d="M4.191875,4.816875 C4.031875,4.816875 3.871875,4.755625 3.75,4.63375 L0,0.88375 L0.88375,0 L4.191875,3.308125 L7.5,0 L8.38375,0.88375 L4.63375,4.63375 C4.511875,4.755625 4.351875,4.816875 4.191875,4.816875 Z" id="Path"></path>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
`;

export default arrowrightIcon;
